import styled from 'styled-components';

import { Grid } from '@dexma/ui-components';
import { linkHeaderHeight, linkResponsiveHeaderHeight } from 'adapter/in/dashboards/pages/globalStyles';

export default styled(Grid)<{ $isLandscape: boolean }>`
    padding-right: 0.5rem;
    padding-left: 0.5rem;
    height: 100vh;

    .layout {
        overflow: hidden;
        position: relative;
        height: calc(100% - ${(props) => (props.$isLandscape ? linkHeaderHeight : linkResponsiveHeaderHeight)});
    }
`;
